import account from './account/store/module'
import market from './market/store/module'
import createPersistedState from "vuex-persistedstate";

export default {
  modules: {
    account,
    market
  },

  plugins: [createPersistedState({
    key: 'vuex',
    reducer (val) {
      if(val.account.purgeClientData) {
        return {}
      }
      return val
    }
  })],
}